"use client";

import { motion } from "framer-motion";
import { useRef } from "react";
import { api } from "~/utils/api";
import CommunityManagementBar from "./CommunityManagementBar";
import CommunityPreapprovedHostManagementBar from "./CommunityPreapprovedHostManagementBar";
import CommunityChapterLeadManagementBar from "./CommunityChapterLeadManagementBar";

const CommunitySidebar = ({ communitySlug }: { communitySlug?: string }) => {
    const sidebarRef = useRef<HTMLDivElement>(null);

    const { data: permissions } = api.permissions.getUserPermissions.useQuery({
        adminCheck: true,
        community: {
            slug: communitySlug,
        },
    });

    const renderSidebar = () => {
        if (permissions?.isManager || permissions?.isAdmin) {
            return <CommunityManagementBar permissions={permissions} />;
        }
        if (permissions?.isPreapprovedHost) {
            return (
                <CommunityPreapprovedHostManagementBar
                    permissions={permissions}
                />
            );
        }
        if (!!permissions?.isChapterLeadForCommunity) {
            // check if any of the chapter leads chapters belong to this community
            return (
                <CommunityChapterLeadManagementBar permissions={permissions} />
            );
        }
    };

    return (
        <>
            <motion.div
                ref={sidebarRef}
                initial={{ x: "-100%", z: 10 }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{
                    duration: 0.3,
                    ease: "easeInOut",
                }}
            >
                {renderSidebar()}
            </motion.div>
        </>
    );
};

export default CommunitySidebar;
